import { useEffect } from "react";
import { IonCard, IonCardContent } from "@ionic/react";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import WithNavigation from "../../hoc/with-navigation";
import TvmForm from "../../components/common/tvm-form";
import { useSystem } from "../../store/system";
import { TvmFormSubmitResult } from "../../components/common/tvm-form/form-definition";
import { printNumber } from "../../utils/helpers";

import "./styles.css";


const FORM_ID = "propulsion";

interface PropulsionFormData {
	mainPower: number;
	speed: number;
	usePercentage: number;
	_evaluationResult: PropulsionResult;
}

interface PropulsionResult {
	totalForceNozzle: number | null;
	cableStrainNozzle: number | null;
	totalForceNoNozzle: number | null;
	cableStrainNoNozzle: number | null;
}

const Propulsion = () => {
	const { systemId } = useParams<any>();

	const systemStore = useSystem();

	const { t } = useTranslation();

	const updateResults = (data: TvmFormSubmitResult<PropulsionFormData>) => {
		systemStore.submitFormResult(systemId, FORM_ID, data);
	};

	useEffect(() => {
		systemStore.loadForm(FORM_ID);
		systemStore.loadFormResult(systemId, FORM_ID);
	}, []);

	return (
		<>
			<WithNavigation
				hintsContent={{
					title: systemStore.currentForm?.hints.title,
					htmlDef: systemStore.currentForm?.hints.htmlDef,
				}}
				preventGoBack={false}
				text={t("system.propulsion.title")}
			>
				<div className="form">
					{systemStore.currentForm && (
						<>
							{systemStore.formResultReqInfo?.finished && (
								<TvmForm
									title={t("system.propulsion.title")}
									systemName={systemId}
									topImage="/assets/propeller.png"
									definition={systemStore.currentForm}
									fieldValues={systemStore.currentFormValues}
									onSubmit={updateResults}
								/>
							)}
							{systemStore.formFlags?.nozzle && (
								<>
									<IonCard>
										<IonCardContent>
											<div className="ion-text-center">
												<h5 className="calcResultTitle">
													{t("system.propulsion.totalForceNozzle")}
												</h5>
												<p className="calcResultValue">
													{systemStore.formResult?.totalForceNozzle
														? `${printNumber(
																systemStore.formResult?.totalForceNozzle,
																2
														  )} kgf`
														: "-"}
												</p>
											</div>
										</IonCardContent>
									</IonCard>
									<IonCard>
										<IonCardContent>
											<div className="ion-text-center">
												<h5 className="calcResultTitle">
													{t("system.propulsion.cableStrainNozzle")}
												</h5>
												<p className="calcResultValue">
													{systemStore.formResult?.cableStrainNozzle
														? `${printNumber(
																systemStore.formResult?.cableStrainNozzle,
																2
														  )} kgf`
														: "-"}
												</p>
											</div>
										</IonCardContent>
									</IonCard>
								</>
							)}
							{!systemStore.formFlags?.nozzle && (
								<>
									<IonCard>
										<IonCardContent>
											<div className="ion-text-center">
												<h5 className="calcResultTitle">
													{t("system.propulsion.totalForceNoNozzle")}
												</h5>
												<p className="calcResultValue">
													{systemStore.formResult?.totalForceNoNozzle
														? `${printNumber(
																systemStore.formResult?.totalForceNoNozzle,
																2
														  )} kgf`
														: "-"}
												</p>
											</div>
										</IonCardContent>
									</IonCard>
									<IonCard>
										<IonCardContent>
											<div className="ion-text-center">
												<h5 className="calcResultTitle">
													{t("system.propulsion.cableStrainNoNozzle")}
												</h5>
												<p className="calcResultValue">
													{systemStore.formResult?.cableStrainNoNozzle
														? `${printNumber(
																systemStore.formResult?.cableStrainNoNozzle,
																2
														  )} kgf`
														: "-"}
												</p>
											</div>
										</IonCardContent>
									</IonCard>
								</>
							)}
						</>
					)}
				</div>
			</WithNavigation>
		</>
	);
};

export default Propulsion;
